import { Icons } from '@/components/atoms/Icons/Icons'
import { cn } from '@/lib/utils'

export type PromotionStatus = 'enabled' | 'disabled'
export type PromotionType = 'email' | 'star' | 'carrousel'

export interface PromotionStatusIconProps {
  value?: PromotionStatus | boolean | null
  type: PromotionType
  className?: string
}

export const PromotionStatusIcon = ({ value, type, className }: PromotionStatusIconProps) => {
  if (value === undefined || value === null) return null

  if (value === 'disabled' || value === false) {
    return <Icons.promotionDisabled className={cn('text-red-500', className)} />
  }

  switch (type) {
    case 'email':
      return <Icons.promotionEmail className={cn('text-blue-500', className)} />
    case 'star':
      return <Icons.promotionStar className={cn('fill-current text-yellow-500', className)} />
    case 'carrousel':
      return <Icons.promotionCarrousel className={cn('fill-current text-yellow-500', className)} />
    default:
      return null
  }
}
